@if (netLosses) {
  <div>
    <div>
      <strong class="space-right">Monthly</strong>
      <span>{{ netLosses.monthly }}</span>
    </div>
    <div>
      <strong class="space-right">Lifetime</strong>
      <span>{{ netLosses.lifetime }}</span>
    </div>
  </div>
}
